const aktivitasData = [
  {
    namaAct: 'Menambahkan lokasi baru kantor cabang',
    pelakuAct: 'Pelaku 1',
    lokasiAct: 'Jagakarsa',
    tglAct: 'Hari ini, 06:00',
  },
  {
    namaAct: 'baru saja menghapus sublokasi KCP Tebet 4 dari induk',
    pelakuAct: 'Pelaku 2',
    lokasiAct: 'Kantor Cabang Tebet',
    tglAct: 'Kemaren, 17:32',
  },
  {
    namaAct: 'melakukan perubahan profil pada Induk Cabang Kantor',
    pelakuAct: 'Pelaku 1',
    lokasiAct: 'Bekasi',
    tglAct: 'Kemaren, 17:32',
  },
];

export default aktivitasData;
